export const DEFAULT_TRANSLOADIT_CLIENT_KEY = 'FW8zu5M9fhZDNRJQvsJapZ4a1QdrwLUK';
export const DEFAULT_TRANSLOADIT_TEMPLATE_ID = '9fe2b030809a11e4943d19e60b9af16b';
